<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section schedules">
    <header class="shared-section-header">
      <h2 class="shared-section-header-heading">{{ $t('schedule.header') }}</h2>
    </header>
    <div class="mb-8">
      <h3 class="text-2xl font-semibold mb-1">{{ $t('schedule.heading') }}</h3>
      <p>{{ $t('schedule.subheading') }}</p>
    </div>
    <ScheduleList :trainings="trainings" />
    <ScheduleVideosRecord :trainings="allTrainings" />
  </section>
</template>

<script>
import { mapState } from 'vuex';

import VLoader from '@/components/base/VLoader';
import ScheduleList from '@/components/customer/ScheduleList';
import ScheduleVideosRecord from '@/components/customer/ScheduleVideosRecord';

export default {
  name: 'Schedules',
  components: { ScheduleList, VLoader, ScheduleVideosRecord },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    trainings: state => state.customer.trainings,
    allTrainings: state => state.customer.allTrainings,
  }),
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('customer/getTrainings');
    await this.$store.dispatch('customer/getAllTrainings');
    this.loading = false;
  },
};
</script>
